import { EventEmitter, Injectable } from '@angular/core';
import { ExternalWalletPayload } from '../model/ExternalWalletPayload';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  connection: WebSocket;
  messageMaxInterval = 60;

  lastMessageTime: Date;
  connectionCheck: any;

  closeConnection: EventEmitter<void> = new EventEmitter<void>();
  onTransferStatusUpdate: EventEmitter<any> = new EventEmitter<any>();
  onAssetUpdate: EventEmitter<any> = new EventEmitter<any>();
  onBalanceUpdate: EventEmitter<any> = new EventEmitter<any>();
  onExternalWallets: EventEmitter<ExternalWalletPayload> =
    new EventEmitter<ExternalWalletPayload>();

  checkConnection() {
    this.connectionCheck = setInterval(() => {
      const now = new Date();
      const timeDiff = now.getTime() - this.lastMessageTime.getTime();
      const timeDiffInMinutes = timeDiff / 1000 / this.messageMaxInterval;
      if (timeDiffInMinutes >= 1) {
        console.log('Connection lost, reconnect');
        this.reconnect();
      }
    }, this.messageMaxInterval * 1000);
  }

  reconnect() {
    clearInterval(this.connectionCheck);
    console.log('Attempting to reconnect...');

    const reconnectInterval = setInterval(() => {
      if (
        window.navigator.onLine &&
        this.connection &&
        this.connection.readyState === this.connection.OPEN
      ) {
        console.log('Successfully reconnected!');
        clearInterval(reconnectInterval);

        // Starting checkConnection again
        this.checkConnection();
      } else {
        console.log('Retrying to connect...');
        this.initSocket();
      }
    }, 3 * 1000);
  }

  initSocket() {
    const fullPath = `/cw/ws/transferstatusupdate`;
    this.connection = new WebSocket(fullPath);

    this.connection.onopen = () => {
      this.checkConnection();
    };

    this.connection.onclose = () => {
      console.log('disconnected');
      clearTimeout(this.connectionCheck);
    };

    this.connection.onerror = function (error) {
      console.log('error');
      console.log(error);
    };

    const onMessage = (message) => {
      this.lastMessageTime = new Date();
      this.handleMessage(message);
    };
    this.connection.onmessage = async function (message) {
      onMessage(message);
    }.bind(this);
  }
  handleMessage(message: any) {
    const parsed = JSON.parse(message.data);
    switch (parsed.event) {
      case 'BalanceUpdate':
        this.onBalanceUpdate.emit(parsed.payload);
        break;
      case 'Assets':
        this.onAssetUpdate.emit(parsed.payload);
        break;
      case 'TransferStatusUpdate':
        this.onTransferStatusUpdate.emit(parsed.payload);
        break;
      case 'ExternalWallets':
        this.onExternalWallets.emit(parsed.payload);
        break;
    }
  }

  public disconnectUser(): void {
    if (this.connection) {
      this.connection.close();
      this.connection = null;
    }
  }
}
